import React from 'react';
import { Box, Heading, Text, useColorModeValue } from '@chakra-ui/react';

export default function EmptyState({ title, description, minH = '180px' }) {
  const bg = useColorModeValue(
    'rgba(248, 250, 255, 0.88)',
    'rgba(14, 21, 38, 0.75)',
  );
  const border = useColorModeValue(
    'rgba(162, 176, 210, 0.22)',
    'rgba(255,255,255,0.08)',
  );

  return (
    <Box
      minH={minH}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      border="1px dashed"
      borderColor={border}
      borderRadius="22px"
      bg={bg}
      px="24px"
    >
      <Heading size="sm" mb="8px">
        {title}
      </Heading>
      <Text color="secondaryGray.700" maxW="420px">
        {description}
      </Text>
    </Box>
  );
}
